<script>
import TabelMainExportQueue from "./tabel-main-export-queue.vue";

export default {
  components: {
    TabelMainExportQueue,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    onShown() {
      this.$refs.tabelQueue.getDataTable();
    },
  },
};
</script>

<template>
  <b-modal
    v-model="show"
    title="Export List Queue"
    size="xl"
    hide-footer
    body-class="p-0"
    @shown="onShown"
  >
    <b-tabs class="bigNav nav-primary nav-pills" content-class="mt-3 p-3" fill>
      <b-tab title="Antrian Export Proctor">
        <TabelMainExportQueue ref="tabelQueue" :type="type" />
      </b-tab>
      <b-tab title="Semua Antrian">
        <div class="alert alert-info">
          <i class="fas fa-info-circle"></i> Dalam Pengerjaan.
        </div>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>